<div class="row justify-content-center">
    <div class="col-lg-8">
        <div class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">Información de pruebas</h4>
            </div>
            <div class="card-body">
                <div class="form-body">
                        <div class="row p-t-20">
                            <div class="col-12">
                                <div class="form-group">
                                    <label class="control-label">Seleccionar test</label>
                                    <select [(ngModel)]="testInfo.type" (ngModelChange)="selectInfo($event)" class="form-control custom-select">
                                        <option disabled value="">Seleccionar</option>
                                        <option value="16PF">16PF</option>
                                        <option value="CLEAVER">CLEAVER</option>
                                        <option value="ALL PORT">ALLPORT</option>
                                        <option value="TERMAN">TERMAN</option>
                                        <option value="KOSTIK">KOSTICK</option>
                                        <option value="ZAVIC">ZAVIC</option>
                                        <option value="IPV">IPV</option>
                                        <option value="BARSIC">BARSIT</option>
                                        <option value="MMPI2">MMPI2</option>
                                        <option value="MMPIA">MMPIA</option>
                                        <option value="BIS11">BIS-11</option>
                                        <option value="MIPS">MIPS</option>
                                        <option value="CHASIDE">CHASIDE</option>
                                        <option value="DOMINO">DOMINO</option>
                                    </select>

                                </div>
                            </div>
                            <div class="col-12">
                                <div class="NgxEditor__Wrapper p-20 m-b-40 col-10">
                                    <ngx-editor-menu [editor]="editor"> </ngx-editor-menu>
                                    <ngx-editor [editor]="editor" [(ngModel)]="html" [placeholder]="'Escriba su texto...'"></ngx-editor>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label class="control-label">Link de reporte</label>
                                    <input type="text" class="form-control" [(ngModel)]="testInfo.link" placeholder="Link al reporte">
                                </div>
                            </div>


                            <div class="col-12">

                                <h3>Valores agregados <button (click)="handleAddNewRow()" class="btn btn-info btn-sm">+ Agregar</button></h3>
                                <table class="w-100 my-3">
                                    <tr>
                                        <th>Test</th>
                                        <th>Acciones</th>
                                    </tr>
                                    <tr *ngFor="let row of testInfo.rows; index as i">
                                        <td>{{row.title}}</td>
                                        <td>
                                            <button class="btn btn-sm btn-icon btn-pure btn-outline mx-1" (click)="moveRowPosition(i, 'down')"><i class="fa fa-arrow-down" aria-hidden="true"></i></button>
                                            <button class="btn btn-sm btn-icon btn-pure btn-outline mx-1" (click)="moveRowPosition(i, 'up')"><i class="fa fa-arrow-up" aria-hidden="true"></i></button>
                                            <button class="btn btn-sm btn-icon btn-pure btn-outline mx-1" (click)="handleDeleteRow(i)" ><i class="fa fa-trash-o"></i></button>
                                            <button class="btn btn-sm btn-icon btn-pure btn-outline mx-1" (click)="handleEditRow(i)" ><i class="fa fa-pencil" ></i></button>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        
                    </div>
                    <button class="btn btn-info mt-3" (click)="create()" >Actualizar información</button>
            </div>


        </div>

    </div>

</div>


<div id="row-modal" class="modal fade bs-example-modal-sm" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" style="display: none;">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="mySmallModalLabel">Ítem informativo</h4>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <div class="form-group ">
                    <div class="col-12">
                        <div class="form-group">
                            <label class="control-label">Concepto</label>
                            <input type="text" class="form-control" [(ngModel)]="row.title" placeholder="Concepto">
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group">
                            <label class="control-label">Descripción</label>
                            <textarea [(ngModel)]="row.description" class="form-control" rows="4"></textarea>
                        </div>
                    </div>
                    <div class="col-12">
                        <input type="file" (change)="uploadImage($event)" >
                        <img *ngIf="row.imageUrl" class="w-100 mt-3" [src]="row.imageUrl" alt="">
                    </div>
                    
                </div> 
                <button class="btn btn-info btn-rounded" (click)="addRow()" >{{editingRowIndex >= 0 ? 'Actualizar' : 'Agregar'}}</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>